<ng-container *transloco="let t">
  <app-page-template [showFooter]="!isMobile" [showPageHeader]="!isMobile">
  <app-my-tracey-page-header [backgroundColor]="isMobile ? 'var(--grey-1000)' : 'white'" [color]="isMobile ? 'white' : 'var(--slate-800)'"
                             [key]="'event.item.my.entry'" (onBackCallback)="goBack()"></app-my-tracey-page-header>
    <div class="container" [ngClass]="{'scrollable-container': isMobile && isRegistrationOwner}">
      @if (!isMobile) {
        <div class="row mt-4 pb-300-100">
          <div class="col-md-custom-70">
            <ng-template [ngTemplateOutlet]="eventInfo"></ng-template>
            @if (!isFinishedEvent) {
              <ng-template [ngTemplateOutlet]="paidSection"></ng-template>
            }
            <!--<ng-template [ngTemplateOutlet]="paymentInfo"></ng-template>-->
            <ng-template [ngTemplateOutlet]="competitorInfo"></ng-template>
          </div>
          <div class="col-md-custom-30">
            <!--<ng-template [ngTemplateOutlet]="paymentSummary"></ng-template>-->
            <ng-template [ngTemplateOutlet]="dropdowns"></ng-template>
          </div>
        </div>

    } @else {
      <div class="d-flex flex-column h-100" style="padding-bottom: 200px">
        <ng-template [ngTemplateOutlet]="eventInfo"></ng-template>
        @if (!isFinishedEvent) {
          <ng-template [ngTemplateOutlet]="paidSection"></ng-template>
        }
        <!--<ng-template [ngTemplateOutlet]="paymentInfo"></ng-template>-->
        <ng-template [ngTemplateOutlet]="competitorInfo"></ng-template>
        <ng-template [ngTemplateOutlet]="dropdowns"></ng-template>
      </div>
      }
    </div>
  <ng-template #eventInfo>
    <div class="section p-16 position-relative d-flex flex-column mt-md-0 mt-3">
      <div class="flex-grow-1 overflow-hidden">
        @if (isFinishedEvent) {
          <div class="tag green absolute absolute--top-xs">
            <p class="text-uppercase">{{ t("event.item.status.2") }}</p>
          </div>
        }

        <p class="fw-semibold fs-18">
          <app-language-output
            [hrLabel]="event?.name"
            [enLabel]="event?.nameEng"
            [itLabel]="event?.nameIta"
            [siLabel]="event?.nameSlo"
            [srLabel]="event?.nameSr"
            [bsLabel]="event?.nameBs"
            [defaultLanguage]="event?.defaultLanguage"
            [languages]="languages">
          </app-language-output>
        </p>

        <div class="d-flex justify-content-between align-items-end">
          <p class="fs-16 color-slate-600">
            <app-language-output
              [hrLabel]="race?.name"
              [enLabel]="race?.nameEng"
              [itLabel]="race?.nameIta"
              [siLabel]="race?.nameSlo"
              [srLabel]="race?.nameSr"
              [bsLabel]="race?.nameBs"
              [defaultLanguage]="event?.defaultLanguage"
              [languages]="languages">
            </app-language-output>
          </p>

          <p *ngIf="!isMobile" class="fw-500 fs-14 color-teal-500 cursor-pointer" (click)="goToEventDetailsPage(event)"> {{ t('app.common.view.event') }}</p>
        </div>

      </div>

      <div class="divider-horizontal margin-8"></div>

      <div class="d-flex flex-column gap-2 flex-md-row gap-md-0 align-items-md-center justify-content-md-between">
        <div class="d-flex flex-column flex-md-row">
          <div class="color-slate-600" [style.padding-left]="isMobile ? '0.2rem' : ''">
            <app-event-date-display [start]="race?.raceStart" [end]="race?.raceEnd"/>
          </div>
          <i *ngIf="!isMobile" class="bi bi-dot"></i>
          <div class="d-flex align-items-center justify-content-between justify-content-md-start">
            <app-location-display [showIcon]="false" [city]="event?.city" [countryId]="event?.country"/>
            <p *ngIf="isMobile" class="fw-500 fs-14 color-teal-500 align-items-end" (click)="goToEventDetailsPage(event)">
              {{ t('app.common.view.event') }}
            </p>
          </div>
        </div>

        <div class="section mint color-teal-500 fw-500 d-flex align-items-center gap-2 fs-14" style="width: fit-content;">
          <img src="assets/icons/icons-alt/teal-dot-lg.svg" alt="Dot"/>
          @if (daysRemaining! > 0) {
            {{t('my.entry.event.starts.in', {days: daysRemaining} )}}
          } @else {
            {{t('my.entry.event.started')}}
          }
        </div>
      </div>
    </div>
  </ng-template>

    <ng-template #paidSection>
      <div class="section mt-3 p-12">
        <div class="d-flex align-items-center gap-1">
          <img [src]="userEvent?.registrationStatus === RegistrationStatus.CONFIRMED
                  ? 'assets/icons/icons-alt/warning-icon-green.svg'
                  : 'assets/icons/icons-alt/warning-icon-red.svg'"
               alt="Warning"
               class="p-1" style="justify-self: center; height: 26px;"/>
          <div class="text-uppercase fw-500 d-inline-flex"
               [class.color-green-dark]="userEvent?.registrationStatus === RegistrationStatus.CONFIRMED"
               [class.color-red-600]="userEvent?.registrationStatus !== RegistrationStatus.CONFIRMED"
          >
            <p class="pe-1">{{ t('app.common.registrationStatus.' + (userEvent?.registrationStatus ?? 0)) }}</p>
            <p class="pe-1"> - </p>
            <p class="pe-1"> {{t(userEvent?.registrationStatus === RegistrationStatus.CONFIRMED ? 'event.item.payment.completed' : 'event.item.payment.not.completed')}} </p>
          </div>
        </div>
      </div>
    </ng-template>

  <ng-template #paymentInfo>
    <div class="mt-3 section-mobile p-3 p-md-0">
      <app-my-entry-status [registrationConfirmed]="registrationConfirmed" [isOwner]="isRegistrationOwner ?? false" [owner]="userEvent?.owner"></app-my-entry-status>
      @if (!paymentCompleted && userEvent?.raceRegistration?.totalAmountWithDiscount && isMobile && isRegistrationOwner) {
      <div class="section my-3 p-16">
        <div class="d-flex justify-content-between align-items-center">
          <p class="color-slate-600">
            {{ t('my.entry.payment.amount.due') }}
         </p>
          <p>
             {{userEvent!.raceRegistration!.totalAmountWithDiscount |  myCurrency:userEvent!.raceRegistration!.currencyCode:true}}
          </p>
       </div>
      @if (userEvent?.raceRegistration?.endDateForPayment) {
      <div class="d-flex justify-content-between align-items-center">
        <p class="color-slate-600">
          {{ t('my.entry.payment.deadline') }}
        </p>
        <p class="color-slate-600">
          <app-event-date-display [start]="userEvent!.raceRegistration!.endDateForPayment"/>
        </p>
      </div>
      }
      </div>

      <app-button-alt
        [text]="t('app.register.to.race.proceed.to.payment') | uppercase"
        [buttonHeight]="'44px'"
        [isFullWidth]="true"
        (onClickCallback)="goToCompletePayment()">
      </app-button-alt>
      }
    </div>
  </ng-template>

  <ng-template #competitorInfo>
    <div class="section p-16 my-3">
      <div class="border-primary br-8 bck-tertiary d-flex flex-column align-items-center justify-content-center py-12 mb-3">
        <p class="text-uppercase fs-14 fw-500 color-slate-800">
          {{ t('my.entry.race.bib.number') }}
        </p>
        @if (competitor?.startNumber) {
          <p class="color-slate-800 fw-bold fs-20-16">
            {{ competitor?.startNumber }}
          </p>
        } @else {
          <p class="color-slate-600 fs-16">
            {{ t('my.entry.race.bib.number.unassigned') }}
          </p>
        }
        @if (competitor?.startBlock) {
          <p class="text-uppercase fw-500 color-slate-800 fs-14-12">
            {{t('my.entry.race.start.block')}} {{ competitor?.startBlock }}
          </p>
        }
      </div>

      <div class="info-grid" [class.grid-2x2]="!startAndFinishEqual" [class.grid-2x1]="startAndFinishEqual">
        <div class="info-cell">
          <p class="text-uppercase fs-12 fw-500 color-slate-500">
            {{ t('event.item.start.time') }}
          </p>
          <p class="fs-16">
            {{ race ? (race.raceStart | localizedDate:'shortTime') : '-' }}
          </p>
        </div>
        <div class="info-cell">
          <p class="text-uppercase fs-12 fw-500 color-slate-500">
            {{ t('race.registration.settings.ageCategory') }}
          </p>
          <p class="fs-16">
            {{ competitor?.categoryLabel ?? '-' }}
          </p>
        </div>

        <!--
        <div class="info-cell location-cell">
          <div class="d-flex justify-content-between align-items-center">
            <p class="text-uppercase fs-12 fw-500 color-slate-500">
              {{t(startAndFinishEqual ?  'app.common.locationStartFinish' : 'app.common.locationStart')}}
            </p>
            <ng-template [ngTemplateOutlet]="mapButton" [ngTemplateOutletContext]="{waypoint: startWaypoint}"></ng-template>
          </div>
          <p class="fs-14 pe-60">
            <ng-template [ngTemplateOutlet]="address" [ngTemplateOutletContext]="{waypoint: startWaypoint}"></ng-template>
          </p>
        </div>

        @if (!startAndFinishEqual) {
        <div class="info-cell location-cell">
          <div class="d-flex justify-content-between align-items-center">
            <p class="text-uppercase fs-12 fw-500 color-slate-500">
              {{t("app.common.locationFinish")}}
            </p>
            <ng-template [ngTemplateOutlet]="mapButton" [ngTemplateOutletContext]="{waypoint: finishWaypoint}"></ng-template>
          </div>

          <p class="fs-14 pe-60">
            <ng-template [ngTemplateOutlet]="address" [ngTemplateOutletContext]="{waypoint: finishWaypoint}"></ng-template>
          </p>
        </div>
        }
        -->
      </div>
    </div>
  </ng-template>

  <ng-template #dropdowns>
    <div class="section p-16 mb-3">
      <ng-template [ngTemplateOutlet]="myEntryDropdown" [ngTemplateOutletContext]="{
      img: 'personal-info.svg',
      title: t('my.entry.personal.info.title'),
      description: t('my.entry.personal.info.description'),
      type: 'personal',
      }"></ng-template>
    </div>
  </ng-template>

 <ng-template #paymentSummary>
<!--   <div *ngIf="!registrationConfirmed">-->
<!--     <div [ngClass]="{'section mb-3 p-16 mt-3': !isMobile}" class="d-flex flex-column">-->
<!--         <p *ngIf="!isMobile" class="fs-20"> {{ t('app.register.to.race.payment.summary') }}</p>-->
<!--         <div *ngIf="!isMobile" class="divider-horizontal my-3"></div>-->
<!--         <div [ngClass]="isMobile ? 'd-flex justify-content-between align-items-center' : 'd-flex flex-column gap-2'">-->
<!--             <app-amount-status-badge [amountStatus]="amountStatus"></app-amount-status-badge>-->
<!--             @if (isRegistrationOwner) {-->
<!--             <div class="d-flex justify-content-between align-items-center" [ngClass]="isMobile ? '' : 'flex-column'">-->
<!--                 @if (isMobile) {-->
<!--             <div class="d-flex fs-14 color-slate-600 me-2 justify-content-between align-items-center">-->
<!--                 <div class="me-1">-->
<!--                     {{t('my.entry.payment.by')}}-->
<!--                 </div>-->
<!--                 <div>-->
<!--                     <p class="color-slate-600">-->
<!--                         <app-event-date-display [start]="userEvent?.raceRegistration?.endDateForPayment"/>-->
<!--                     </p>-->
<!--                 </div>-->
<!--             </div>-->
<!--             }-->
<!--             <div class="d-flex fs-16 color-slate-600 me-2 justify-content-between align-items-center" [ngClass]="isMobile ? '' : 'w-100 pt-3'">-->
<!--                @if (!isMobile) {-->
<!--             <div class="ps-2">-->
<!--                 {{ t('my.entry.payment.amount.due') }}-->
<!--             </div>-->
<!--             }-->
<!--             <div class="fw-500">-->
<!--             {{-->
<!--             userEvent?.raceRegistration?.totalAmountWithDiscount |  myCurrency:userEvent?.raceRegistration?.currencyCode:true-->
<!--             }}-->
<!--             </div>-->
<!--         </div>-->
<!--         @if (!isMobile) {-->
<!--             <div class="d-flex justify-content-start align-items-center fs-16 w-100 pt-2">-->
<!--                 <div class="d-flex align-items-start">-->
<!--                     <i class="bi bi-clock card-body__icon fs-16 pe-2"-->
<!--                        style="justify-self: center; -webkit-text-stroke: 0.7px var(&#45;&#45;teal-500);"></i>-->
<!--                     <p class="color-slate-600 pe-2">-->
<!--                         {{ t('my.entry.payment.deadline') }}-->
<!--                     </p>-->
<!--                 </div>-->
<!--                 <p class="color-slate-600 fw-500">-->
<!--                     <app-event-date-display [start]="userEvent?.raceRegistration?.endDateForPayment"/>-->
<!--                 </p>-->
<!--             </div>-->
<!--             }-->
<!--             </div>-->
<!--             }-->
<!--             @else {-->
<!--             <p class="color-slate-600 py-2 fs-14">-->
<!--             {{ t('my.entry.payment.waiting.for.payer') }}-->
<!--             </p>-->
<!--             @if (userEvent?.owner) {-->
<!--                <div class="divider-horizontal"></div>-->
<!--                <p class="color-slate-600 py-2 fs-14">-->
<!--                    {{ t('my.entry.payment.assigned.to') }}:-->
<!--                    <strong>{{ userEvent?.owner?.firstName ?? '' }} {{userEvent?.owner?.lastName ?? ''}}</strong>-->

<!--                </p>-->
<!--                }-->
<!--             }-->
<!--         </div>-->
<!--         @if (isRegistrationOwner) {-->
<!--         <div class="mt-3 w-100">-->
<!--             <app-button-alt-->
<!--                     [text]="t('app.register.to.race.proceed.to.payment') | uppercase"-->
<!--                     [buttonColor]="'var(&#45;&#45;teal-500)'"-->
<!--                     [borderColor]="'var(&#45;&#45;teal-500)'"-->
<!--                     [textColor]="'white'"-->
<!--                     [buttonHeight]="'44px'"-->
<!--                     [isFullWidth]="true"-->
<!--                     (onClickCallback)="goToCompletePayment()">-->
<!--             </app-button-alt>-->
<!--         </div>-->
<!--         <div *ngIf="onlinePayment" class="pt-3 d-flex justify-content-start align-items-center">-->
<!--             <p class="fs-14 color-slate-600">-->
<!--                 Secure online payment-->
<!--             </p>-->
<!--         </div>-->
<!--         }-->
<!--     </div>-->
<!--   </div>-->

 </ng-template>

  <ng-template #myEntryDropdown
  let-imgSrc="img" let-title="title" let-description="description"
               let-dropdownType="type" let-isDisabled="disabled"
  >
    <div class="dropdown-wrapper mb-3 cursor-pointer">
      <div class="section d-flex justify-content-between align-items-center gap-3 box-shadow-sm box-shadow-sm--sm-none p-10-0"
           [class.no-bottom-radius]="dropdownOpened === dropdownType"
           [class.is-disabled]="isDisabled"
           [style.background-color]="isMobile ? '' : 'var(--teal-50)'"
           [style.height]="isMobile ? '' : '72px'"
           [style.border]="isMobile ? '' : 'border-light-gray'">
        <div class="d-flex align-items-center gap-3">
          <div class="section dropdown-icon d-flex justify-content-center align-items-center">
            <img src="assets/icons/icons-alt/{{imgSrc}}" alt="Addon" class="card-body__icon" style="justify-self: center; height: 23px; width: 23px;"/>
          </div>
          <div>
            <p> {{ title }}</p>
            <p class="color-slate-600 fs-14"> {{ description }}</p>
          </div>
        </div>

        <div (click)="toggleDropdown(dropdownType)" class="cursor-pointer">
          <i class="bi fs-18 chevron-icon"
             [class.rotated]="dropdownOpened === dropdownType"
             [ngClass]="'bi-chevron-right'"></i>
        </div>
      </div>

      @if (dropdownOpened === dropdownType) {
        <div class="my-entry-dropdown p-16">
          @switch(dropdownType) {
            @case ('personal') {
              <ng-container [ngTemplateOutlet]="PersonalInfoDropdown"></ng-container>
            }
            @default {
              <p></p>
            }
          }
        </div>
      }
    </div>
  </ng-template>


  <ng-template #PersonalInfoDropdown>
    <div>
      @for (kv of (competitorFields?.options | keyvalue:keepOriginalOrder); track kv.key) {
          @if (kv.value.selected) {
             <div>
              <p>
                {{kv.value.label}}:
              </p>
              <p class="color-slate-600">
                @if (kv.value.isGeneral) {
                @switch (kv.key) {
                    @case('sex') {
                      {{(competitorViewData.sex === 1 || competitorViewData.sex === 2) ? t('app.common.gender.short.' + competitorViewData.sex) : "-"}}
                      }
                    @case ('birthday') {
                      {{competitorViewData.birthday ?? '' | localizedDate:'shortDate'}}
                    }
                    @case ('identityCardExpires') {
                      {{competitorViewData.identityCardExpires ?? '' | localizedDate:'shortDate'}}
                    }
                    @default {
                        {{ ($any(competitorViewData)?.[kv.key]) ?? "-" }}
                    }
                  }
                }
                @if (kv.value.isCustom) {
                {{competitorViewData.customFields?.get(kv.key)}}
                }
              </p>
            </div>
            <div class="divider-horizontal margin-8"></div>
        }
      }

      @if (teamMemberViewData && teamMemberFields) {
      @for (kv of (teamMemberFields?.options | keyvalue:keepOriginalOrder); track kv.key) {
          @if (kv.value.selected) {
            <div>
                <p> {{kv.value.label}}:</p>
              <p class="color-slate-600">
                  @if (kv.value.isGeneral) {
                      @switch (kv.key) {
                          @case('sex') {
                            {{(teamMemberViewData.sex === 1 || teamMemberViewData.sex === 2) ? t('app.common.gender.short.' + teamMemberViewData.sex) : "-"}}
                          }
                         @case ('birthday') {
                            {{teamMemberViewData.birthday ?? '' | localizedDate:'shortDate'}}
                          }
                         @case ('identityCardExpires') {
                            {{teamMemberViewData.identityCardExpires ?? '' | localizedDate:'shortDate'}}
                          }
                          @default {
                            {{ ($any(teamMemberViewData)?.[kv.key]) ?? "-" }}
                          }
                       }
                      }
                  @if (kv.value.isCustom) {
                    {{teamMemberViewData.customFields?.get(kv.key)}}
                  }
              </p>
            </div>
            <div class="divider-horizontal margin-8"></div>
        }
      }
      }

<!--      <app-button-alt-->
<!--        [text]="t('my.entry.personal.info.request.correction') | uppercase"-->
<!--        [buttonColor]="'transparent'"-->
<!--        [borderColor]="'var(&#45;&#45;teal-500)'"-->
<!--        [textColor]="'var(&#45;&#45;teal-500)'"-->
<!--        [buttonHeight]="'36px'"-->
<!--        [isFullWidth]="true"-->
<!--        (onClickCallback)="openPersonalInfo()"-->
<!--        additionalClass="mt-3">-->
<!--      </app-button-alt>-->
    </div>
  </ng-template>

    <ng-template #address let-waypoint="waypoint">
        @if (waypoint?.address || waypoint?.city || waypoint?.country) {
        {{ waypoint?.address || '' }}
        {{ waypoint?.city ? (waypoint?.address ? ', ' : '') + waypoint?.city : '' }}
        {{ waypoint?.country ? ((waypoint?.address || waypoint?.city ? ', ' : '') + (waypoint?.country | country:'iocCode')) : '' }}
        }
        @else {
        -
        }
    </ng-template>
    <ng-template #mapButton let-waypoint="waypoint">
        @if (waypoint?.latitude && waypoint?.longitude) {
        <div class="d-flex align-items-center">
          <p class="fs-14 fw-500 color-teal-500">Map</p>
          <a
            target="_blank"
            rel="noopener"
            title="Open in Google Maps"
            [href]="'https://www.google.com/maps?q=' + waypoint!.latitude! + ',' + waypoint!.longitude!">
            <div class="d-flex location-button ms-2">
              <img src="assets/icons/icons-alt/external-link.svg" alt="Location" class="card-body__icon py-1"/>
            </div>
          </a>
        </div>
        }
    </ng-template>



<!--  <div *ngIf="isMobile && !registrationConfirmed && isRegistrationOwner" slot="footer" class="footer">-->
<!--          <footer class="footer-container">-->
<!--              <ng-template [ngTemplateOutlet]="paymentSummary"></ng-template>-->
<!--          </footer>-->
<!--  </div>-->
  </app-page-template>
</ng-container>
